// One arc per call of the day, 24° apart (the ring of jobbiz_app_v2's
// ProgressCard): green once made, orange for a planned callback, pale blue for
// the rest. Past thirty calls the arcs share the ring and become dots, thinned
// so they never touch. `label` (optional) replaces the « done/total » centre,
// for a screen that counts past the arcs it draws (prospection's banner).
const RING = { size: 76, stroke: 8, gap: 24 };
const RADIUS = (RING.size - RING.stroke) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const CENTER = RING.size / 2;

const CallsRing = ({ done, callbacks, total, label }) => {
  const arcs = Math.max(1, Math.min(total, 30));
  const scale = total > arcs ? arcs / total : 1;
  const green = Math.round(done * scale);
  const orange = Math.round(callbacks * scale);
  const step = 360 / arcs;
  const gap = arcs === 1 ? 0 : Math.min(RING.gap, step);
  const arc = Math.max(0.01, ((step - gap) / 360) * CIRCUMFERENCE);
  const stroke = Math.min(RING.stroke, ((step - 3) / 360) * CIRCUMFERENCE);
  const circle = {
    cx: CENTER,
    cy: CENTER,
    r: RADIUS,
    fill: 'none',
    strokeWidth: stroke,
    strokeLinecap: 'round',
    strokeDasharray: `${arc} ${CIRCUMFERENCE}`,
  };
  return (
    <div className="relative flex size-[76px] shrink-0 items-center justify-center">
      <svg viewBox={`0 0 ${RING.size} ${RING.size}`} className="absolute inset-0" aria-hidden="true">
        {Array.from({ length: arcs }, (_, index) => {
          const tint =
            index < green ? 'stroke-green-500' : index < green + orange ? 'stroke-yellow-500' : null;
          return (
            <g key={index} transform={`rotate(${-90 + gap / 2 + index * step} ${CENTER} ${CENTER})`}>
              <circle {...circle} className="stroke-blue-200" />
              {tint && (
                <circle
                  {...circle}
                  className={`${tint} motion-safe:animate-ringArc`}
                  style={{
                    '--arc': `${arc}px`,
                    animationDelay: `${index * Math.min(140, 1400 / arcs)}ms`,
                  }}
                />
              )}
            </g>
          );
        })}
      </svg>
      {label ? (
        <span className="relative text-base font-bold leading-6 text-gray-900">{label}</span>
      ) : (
        <span className="relative flex items-end">
          <span className="text-xl font-bold leading-7 text-gray-900">{done}</span>
          <span className="text-sm font-medium leading-5 text-gray-600">/{total}</span>
        </span>
      )}
    </div>
  );
};

export default CallsRing;
